import React from 'react';
import { Control } from 'react-redux-form';
import './styles.css';
import arrow from '../../../assets/images/select-arrow.svg';

/**
 * Render single option from predefined properties
 * @param {*} params The parameters to be passed to the option
 */
const renderOption = ({ key, value, displayValue }) => (
  <option key={key} value={value}>{displayValue}</option>
);

/**
 * Render the select component comprise of zero or many options
 * @param {*} props The properties to be passed to the component
 */
const renderSelect = (props) => {
  let options = [];
  if (Array.isArray(props.options)) {
    options = props.options.map(([key, val]) => renderOption({ key, value: key, displayValue: val }));
  } else {
    options = Object.keys(props.options).map(key => renderOption({ key, value: key, displayValue: props.options[key] }));
  }

  return (
    <div styleName="suitabilityControl">
      <Control.select
        styleName="suitabilityRowSelect"
        {...props}
      >
        { options }
      </Control.select>
      <img
        styleName="filterArrow"
        src={arrow}
        alt="arrow"
      />
    </div>
  );
};

const Component = props => renderSelect(props);

Component.displayName = 'SuitabilityDropdown';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Suitability/SuitabilityDrowdown.js